import Header from "@/components/sitemap-html/header";
import { BiSitemap } from "react-icons/bi";
import Link from "next/link";


const SitemapHtml = (props) => {
    return (
        <>
            <Header />
            <div className="container">
                <div className="p-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb m-0">
                            <li className="breadcrumb-item active fs-5" aria-current="page"><BiSitemap /> Sitemap</li>
                        </ol>
                    </nav>
                </div>
                <div className="card bg-transparent border-0  mb-5">
                    <ul className="list-group list-group-flush mds-list-group-flush">
                        <li className="list-group-item">
                            <Link href={`/sitemap-html/stacks`}>
                                <a className=" mds-text-primary">Stacks</a>
                            </Link>
                        </li>
                        <li className="list-group-item">
                            <Link href={`/sitemap-html/companies`}>
                                <a className=" mds-text-primary">Companies</a>

                            </Link>
                        </li>
                        <li className="list-group-item">
                            <Link href={`/sitemap-html/compare-companies`}>
                                <a className=" mds-text-primary">Compare Companies</a>
                            </Link>
                        </li>
                        <li className="list-group-item">
                            <Link href={`/sitemap-html/posts`}>
                                <a className=" mds-text-primary">Community Posts</a>
                            </Link>
                        </li>
                        <li className="list-group-item">
                            <Link href={`/sitemap-html/journal`}>
                                <a className=" mds-text-primary">Journal</a>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export const getServerSideProps = async (context) => {

    return {
        props: {
        },
    };
};

export default SitemapHtml;

